<template>
  <!-- 加入我们 -->
  <b-row class="about-company">
    <div class="company-text">
      <p>
        <span>汇才汇能是您要找的平台吗？</span>
      </p>
      <p>
        汇才汇能是由一群资深的财税、金融、咨询人士搭建的灵活项目执行平台，我们要更专业又更灵活的为客户提供服务，成为客户的陪伴式顾问。
      </p>
      <p>
        汇才汇能现阶段主要针对具有并购及投资需求的国央企、上市公司及基金公司，提供专业的尽职调查、
        盈利预测及估值服务，同时根据客户需求为其搭建并完善投后管理体系。
      </p>
      <p><span>您是汇才汇能需要的人吗？</span></p>
      <p>
        汇才汇能本着既专业又灵活的用人原则，不管您是谁，是想要全职还是兼职，亦或是实习，只要您有意愿，都有可能在这里找到合适的机会。
      </p>
    </div>
    <div class="join-btn">
      <b-button variant="primary" @click="loginChange" size="lg">
        入汇吧
        <b-icon-arrow-right></b-icon-arrow-right>
      </b-button>
    </div>
  </b-row>
</template>

<script>
import publicChange from "@/assets/js/index.js";
export default {
  methods: {
    login() {
      return publicChange.userLogin();
    },
    loginChange() {
      if (this.login()) {
        this.$router.push("/user/talent");
      } else {
        this.$router.push("/login");
      }
    }
  }
};
</script>
<style>
.join-btn {
  margin: 0 auto;
  text-align: center;
}
</style>
